module.exports = __webpack_public_path__ + "img/cat05.919c3acc.gif";